// Copyright (c) 2019 Comsearch, Inc., All rights reserved

// these objects from API will contain the analysis results
// as well as the polarization state for the given channel pair.
// in redux-form AFS_GRID_RESULTS, we only care about
// channelIndex and polarizationStateId but for
// the interferenceAnalysis redux state, we'll hold on
// to the analysisResults for rendering this static data

const extractAnalysisResults = (afsDisplayAlgorithmResults, numCols) => {
  const extractedResults = {
    analysisResults: [],
    channelPairs: {},
  }

  // if this is null, then there are no AFS calculation results to show here
  // to simply handle this scenario in the UI, we'll create a filler object
  // so the grid structure is rendered properly even though there's no data
  // result data to render within it.
  if (afsDisplayAlgorithmResults === null) {
    // NOTE - we're only adding channelIndex to analysisResults
    // because when an analysis result does not have a color,
    // the polarization input fields will not render for that channel group.
    extractedResults.analysisResults = (
      Array.from({ length: numCols }).map((d, channelIndex) => ({ channelIndex }))
    )

    return extractedResults
  }

  // if we're here, then we had afsDisplayAlgorithmResults so let's iterate over them and
  // separate out their data into two subsets.
  return afsDisplayAlgorithmResults.reduce((a, d, i) => {
    const {
      channelIndex,
      polarizationStateId,
      ...analysisResults
    } = d

    // this will be given to interference analysis redux state
    a.analysisResults.push({
      channelIndex,
      ...analysisResults,
    })

    // this will be given to redux-form
    a.channelPairs['channel_index_' + i] = polarizationStateId

    return a
  }, extractedResults)
}

export default extractAnalysisResults
